import { message } from "antd";
import { showErrorToast } from "V2.0/utils";
import * as projectService from "V2.0/services/projectService";
import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
  DialogDescription,
} from "V2.0/common/dialog";
import {
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableCell,
  TableRow,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";
import { Switch } from "V2.0/common/switch";
import { Badge } from "V2.0/common/badge";
import UserProfile from "../Users/UserProfile";
import { isCustomerOwner } from "V2.0/hooks/useCustomer";

function WorkspaceAccessUsers(props) {
  const { workspace, syncWorkspace, company, users, open, setOpen, onClose } =
    props;

  const updateWorkspace = (updatedWorkspace) => {
    syncWorkspace(updatedWorkspace);
    setOpen((prevState) => {
      return {
        ...prevState,
        workspace: updatedWorkspace,
      };
    });
  };

  const removeUserFromWorkspace = (workspace, userId) => {
    const updatedWorkspace = {
      ...workspace,
      userAdmin: workspace.userAdmin.filter((_userId) => _userId !== userId),
    };

    return updatedWorkspace;
  };

  const addUserToWorkspace = (workspace, userId) => {
    const updatedWorkspace = {
      ...workspace,
      userAdmin: [...workspace.userAdmin, userId],
    };
    return updatedWorkspace;
  };

  const updateUserAccessToWorkspace = async (workspace, user, isActive) => {
    const { firstName, email } = user;
    const emailArray = [email];
    isActive
      ? message.loading(`Adding ${firstName} to ${workspace.name}`)
      : message.loading(`Removing ${firstName} from ${workspace.name}`);
    try {
      const response = await projectService.updateTeamAccess({
        companyId: company._id,
        workspaceId: workspace._id,
        payload: {
          emails: emailArray,
          active: isActive,
        },
      });
      if (response.status === 200) {
        message.destroy();
        isActive
          ? message.success(`Added ${firstName} to ${workspace.name}`)
          : message.success(`Removed ${firstName} from ${workspace.name}`);
        const updatedWorkpsace = isActive
          ? addUserToWorkspace(workspace, user._id)
          : removeUserFromWorkspace(workspace, user._id);
        updateWorkspace(updatedWorkpsace);
      }
    } catch (e) {
      message.destroy();
      showErrorToast(e, "Failed to update access");
    }
  };
  return (
    <Dialog size="xl" open={open} onClose={onClose}>
      <DialogTitle>{workspace.name} Access</DialogTitle>
      <DialogDescription>Grant Access to Users</DialogDescription>
      <DialogBody>
        <Table>
          <TableHead>
            <TableRow>
              <TableHeader>Name</TableHeader>
              <TableHeader className="text-right">Access</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.values(users)?.map((user) => {
              const { firstName, lastName, email, _id } = user;

              const isChecked = workspace.userAdmin?.includes(_id);
              const isOwner = isCustomerOwner(user);

              return (
                <TableRow key={_id}>
                  <TableCell className="font-medium w-1/2">
                    <UserProfile
                      firstName={firstName}
                      lastName={lastName}
                      email={email}
                    />
                  </TableCell>
                  <TableCell className="text-zinc-500 text-right w-1/2">
                    {!isOwner ? (
                      <Switch
                        key={`project-switch-${workspace._id}-${_id}_-${isChecked}`}
                        onChange={(checked) =>
                          updateUserAccessToWorkspace(workspace, user, checked)
                        }
                        aria-label={`Allow access to ${workspace.name}`}
                        name={`allow_access_${workspace._id}`}
                        id={`project-switch-${workspace._id}`}
                        checked={isChecked}
                      />
                    ) : (
                      <Badge color="lime">Admin</Badge>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </DialogBody>
      <DialogActions>
        <Button onClick={onClose}>Done</Button>
      </DialogActions>
    </Dialog>
  );
}

export default WorkspaceAccessUsers;
